import React from 'react';
import { renderFields } from '../../util/RenderUtil';

/** renders a field group checkbox list */
const FieldGroupCheckboxList = props => {
  return (
    <div className="field-group-checkbox-list">
      {renderFields(props)}
    </div>
  );
};

export default FieldGroupCheckboxList;
